var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-preference__reset", attrs: { id: _vm.id } },
    [
      _c(
        "button",
        { staticClass: "pt-ui-btn", on: { click: _vm.provider.resetSettings } },
        [_vm._v(" " + _vm._s(_vm.$t("Search.propver.reset")) + " ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }